import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#1F2833] bg-[#0B0C10] mt-24"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="font-display text-lg font-bold">TraceElements</span>
            <span className="h-2 w-2 rounded-full bg-emerald-400 te-pulse-dot"></span>
          </div>
          <p className="text-sm text-[#C5C6C7] max-w-xs leading-relaxed">
            Intelligent infrastructure. Built by the architects, not middlemen.
          </p>
        </div>
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.22em] text-[#B91C2C] mb-3">// Navigate</div>
          <ul className="space-y-2 text-sm text-[#C5C6C7]">
            <li><Link to="/the-engine" className="hover:text-[#FF3355]" data-testid="footer-link-engine">The Engine</Link></li>
            <li><Link to="/solutions" className="hover:text-[#FF3355]" data-testid="footer-link-solutions">Solutions</Link></li>
            <li><Link to="/terminal" className="hover:text-[#FF3355]" data-testid="footer-link-terminal">Launch Terminal</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.22em] text-[#B91C2C] mb-3">// Signal</div>
          <p className="text-sm text-[#C5C6C7]">
            Status: <span className="text-[#FF3355]">Operational</span>
          </p>
          <p className="text-sm text-[#C5C6C7] mt-1 font-mono">
            v1.0.0 · build {new Date().getFullYear()}
          </p>
        </div>
      </div>
      <div className="border-t border-[#1F2833] py-6 text-center font-mono text-[11px] uppercase tracking-[0.25em] text-[#C5C6C7]/60">
        © {new Date().getFullYear()} TraceElements · Engineered with precision.
      </div>
    </footer>
  );
}
